/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L10_NInputs */

const en_mk_sec_pg_l10_n = /** @type {(inputs: Mk_Sec_Pg_L10_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available by arrangement rather than as a package you download: we prepare and install it on your infrastructure. Contact us for scope and cost.`)
};

const id_mk_sec_pg_l10_n = /** @type {(inputs: Mk_Sec_Pg_L10_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersedia lewat pembicaraan langsung, bukan paket yang bisa Anda unduh sendiri: kami yang menyiapkan dan memasangnya di infrastruktur Anda. Hubungi kami untuk cakupan dan biayanya.`)
};

/**
* | output |
* | --- |
* | "Available by arrangement rather than as a package you download: we prepare and install it on your infrastructure. Contact us for scope and cost." |
*
* @param {Mk_Sec_Pg_L10_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l10_n = /** @type {((inputs?: Mk_Sec_Pg_L10_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L10_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l10_n(inputs)
	return en_mk_sec_pg_l10_n(inputs)
});